import React from 'react';
import LogoPath from '../../../assets/images/logo.svg';

const Logo = () => (
  <div className="logo">
    <img className="logo--image" src={LogoPath} alt="Logo" />
  </div>
);

export default Logo;



// WEBPACK FOOTER //
// src/components/atoms/Logo/index.jsx